<template>
  <BlockWrapper class="block-head">
    <bim-col class="d-flex">
      <div class="head">
        <bim-text type=h5 bold>Получайте вознаграждения от BIMLIB</bim-text>
        <bim-text type=accent class="mt-10 mb-12">даже если не разбираетесь в проектировании и строительстве. <b>Первая партнерская программа в сфере цифровых услуг</b> для участников строительства.</bim-text>
        <ButtonLeaveApplication label="Стать партнером" />
        <bim-row class="privilegions d-flex">
          <bim-col cols=12 md=6 class="d-flex">
            <img width="50px" class="mr-9" :src="getImgPath('landing-cash-2.svg')" alt />
            <bim-text type=main bold>Без необходимости куда-либо ехать</bim-text>
          </bim-col>
          <bim-col cols=12 md=6 class="d-flex mt-9 mt-md-0">
            <img width="50px" class="mr-9" :src="getImgPath('img-special-landing-cash-3.svg')" alt />
            <bim-text type=main bold>Награда в рублях переводом на карту</bim-text>
          </bim-col>
        </bim-row>
      </div>
      <div>
        <img
          alt="money"
          :src="getImgPath('img-special-landing-cash-1@2x.jpg')"
          :srcset="`${getImgPath('img-special-landing-cash-1@3x.jpg')} 2x`"
          class="block-head__img d-none d-lg-block"
        />
      </div>
    </bim-col>
  </BlockWrapper>
</template> 

<script>
import ButtonLeaveApplication from './ButtonLeaveApplication'
import bimRow from '@bimlib/components/bimRow'
import bimCol from '@bimlib/components/bimCol'
import numberSpacing from '@/filters/numberSpacing'

export default {
  name: "block",
  components: {
    bimRow,
    bimCol,
    ButtonLeaveApplication,
  },
  inject: ['getImgPath'],
  filters: {
    numberSpacing,
  },
}
</script>

<style lang="scss" scoped>
.block-head {
  padding: 125px 0 67px;
}
.head {
  .head__number {
    font-size: 50px;
  }
  .head__link {
    font-size: 12px;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-top: 100px;
    line-height: 1.83;
    letter-spacing: 0.5px;
    opacity: .5;
  }
  .privilegions {
    margin-top: 87px;
  }
}
</style>
